import { render } from "./ResponseRespondedPage.vue?vue&type=template&id=34c20f00"
import script from "./ResponseRespondedPage.vue?vue&type=script&lang=js"
export * from "./ResponseRespondedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__